// LocContext.GENERAL
// prettier-ignore
export default {
  // error/WSErrorContainer.tsx
  "c2366e204e86": "[Loading chunk error] Denne typen feil kan av og til rettes med en hard-refresh. (Ctrl+f5 eller CMD+R)",
  "e9622b6a7a6a": "Noe gikk galt",

  // error/wsSentryDialog.tsx
  "a6deb97a6b53": "Noe gikk galt",

  // business-components/apply/ApplyManuallyWithoutProfile.tsx
  "ac70353abea4": "Du har allerede søkt på denne stillingen",
  "27be809e6789": "Ledige stillinger",
  "6383d5878dce": "Søk på stilling",
  "08b5586db2ff": "Søk på stilling",

  // business-components/apply/ApplyWithName.tsx
  "dd01dd412776": "Du har allerede søkt på denne stillingen",
  "0c8dcf3c8d70": "Beklager! Vi klarte ikke å hente navnet ditt.",
  "c57ba9ed3718": "Du må fylle ut fornavn og etternavn i skjemaet under før vi kan fullføre søknaden din.",

  // business-components/apply/ApplyWithoutProfile.tsx
  "4154ecd1fcd8": "Ledige stillinger",
  "f18045324d32": "Søk på stilling",
  "1a03d0796593": "Søk på stilling",
  "cb6bc81f35c4": "Du har allerede søkt på denne stillingen",
  "179fd124d546": "Søk på stilling",
  "21411e9d72f0": "Du må samtykke og velge en av alternativene under for å søke:",
  "443529d967c7": "Du må skrive en søknadstekst, legge ved CV, samtykke og velge en av alternativene under for å søke:",
  "da7726716f6c": "Du må skrive en søknadstekst, samtykke og velge en av alternativene under for å søke:",
  "8156bbe87af0": "Du må legge ved CV, samtykke og velge en av alternativene under for å søke:",

  // business-components/apply/ApplyWithProfile.tsx
  "36bd0844602b": "Du har allerede søkt på denne stillingen",
  "5df758efecf6": "Ledige stillinger",
  "33bb536e3738": "Søk på stilling",
  "b2dc0e49e969": "Søk på stilling",
  "876a9a102014": "Så hyggelig at du ønsker å søke hos oss. For å søke må du skrive en kort søknadstekst, hake av for samtykke og trykke Send søknad.",

  // business-components/common/Consent5000.tsx
  "1dbee8f73676": "Personvernerklæring",
  "83558e5d01b9": "For mer informasjon om hvordan vi behandler dine opplysninger og rettigheter, se her: {0}.",

  // business-components/common/unsavedChanges.tsx
  "7d68a9ea1e22": "Ulagrede endringer",
  "4bd8ed732d45": "Du har ulagrede endringer, er du sikker på at du vil forlate siden?",
  "ccb7993376b7": "Bli værende",
  "7efd3afb6200": "Forlat siden",

  // business-components/common/wsConfirmDialog.tsx
  "187681e35381": "Nei",
  "d9fed4f5b386": "Ja",

  // business-components/dialogs/Consent5000Dialog.tsx
  "f984cb8e1bf3": "Generell samtykkeerklæring for behandling av personopplysninger",
  "29fe24f67c95": "Jeg samtykker ikke",
  "24bf3a80b43f": "Jeg samtykker",

  // business-components/dialogs/DeleteMeDialog.tsx
  "72c12b5da59a": "Du har avvist \"Generell samtykkeerklæring for behandling av personopplysninger\". For å bruke CV-Portalen må du godta samtykkeerklæringen. Hvis du ikke ønsker å godta, må du be om å bli slettet.",
  "88715569533a": "Dersom du ønsker at din profil slettes kan du trykke på knappen under. {0} vil da bli informert og vil gjennomføre slettingen av din profil og personopplysninger så snart som mulig.",
  "4eea11ae3609": "Avbryt",
  "7c9b9d9bb95c": "Lukk",

  // business-components/StopWatch/index.tsx
  "de81c18690e2": "Denne uken: {0} timer",
  "1272ee9b7f44": "Stemple inn/ut",

  // business-components/StopWatch/StopWatchContent.tsx
  "30779b553f9c": "Start arbeidstid",

  // business-components/StopWatch/StopWatchTimeSheetLines.tsx
  "7a084e8180ee": "timer",
  "3d65e6af8ce5": "Kommentar (Skriv før du stopper arbeidstiden)",
  "0dd7c3791b16": "Kommentar:",

  // generic-components/buttons/CvpApplyWithConnectButton.tsx
  "4adcb8beabcb": "Lagre",

  // generic-components/buttons/CvpFormButton.tsx
  "b4e41f387313": "Lagre",

  // generic-components/common/SelectedFile.tsx
  "f3c999b73f46": "Vedlagt fil",

  // generic-components/dialogs/requestStorageAccessDialog.tsx
  "6054de0618b6": "Webtemp trenger tilgang",
  "2f300304db7a": "Gi appen tilgang for å fullføre innlogging",

  // generic-components/messages/CvpToastMessages.tsx
  "d0ff9e20d8b2": "Endringene er lagret",

  // app/pages/CreationSuccessful/index.tsx
  "a63cef1b1ca8": "Din bruker har blitt opprettet. Du kan lukke denne siden.",

  // app/pages/NothingHere/index.tsx
  "90434309120e": "Ingen tilgang",
  "4371338408b4": "Denne funksjonen er ikke slått på",
  "bc688e6577bd": "Det er ingenting her",

  // business-components/forms/formsUI/SPFormikTextArea.tsx
  "9553158a30b7": "{0} tegn igjen",

  // business-components/frontPage/WelcomeSection/index.tsx
  "d941f542911e": "Velkommen til CV-Portalen",
  "656cca179fee": "Velkommen, {0}",

  // business-components/frontPage/WelcomeSection/WelcomeCardContent.tsx
  "d1f59ebde125": "Her kan du enkelt registrere og oppdatere din CV.",
  "1b604f3424d7": "Her kan du enkelt opprette en profil og legge inn din CV.",
  "5ae75aefb4c8": "Jo mer informasjon du legger inn, desto bedre kan vi matche deg med relevante jobber. Start jobbsøkingen ved å klikke på \"Søk stilling\" i våre annonser.",
  "08a7d0de2a40": "Fant du ikke en passende stilling i dag? Registrer din CV her. Vi søker alltid blant våre registrerte kandidater før vi legger ut nye stillinger, så det lønner seg å være registrert hos oss.",
  "a6b4712238d4": "Fant du ikke en passende stilling i dag? Opprett en profil og registrer din CV her. Vi søker alltid blant våre registrerte kandidater før vi legger ut nye stillinger, så det lønner seg å være registrert hos oss.",
  "939023ef30f0": "Logg inn/Registrer deg",
  "6d35684ffc70": "Opprett profil",
  "48a4975ee671": "Velkommen til CV-portalen",

  // business-components/frontPage/WelcomeSection/WelcomeCardPanelButtons.tsx
  "a147cb6f7653": "Oppdater min CV",
  "d78bb2bb7162": "Se mine timelister",
  "c035c646c233": "Les og send meldinger",
  "23ffcb126959": "Se min profil",

  // business-components/nav/MenuItems/useNavItems.ts
  "7cfdece91dd3": "Hjem",
  "9218a26bd617": "Ledige stillinger",
  "fc33916374e4": "Profil",
  "fd1993c883d4": "Timeliste",
  "7a821bbfcf26": "Postkasse",
  "28f2b77e6e7a": "Dokumenter",
  "0fb4e5d60bd0": "Logg inn/Registrer CV",
  "9bfb3315c7f8": "Logg ut",

  // business-components/nav/TopBar/index.tsx
  "ef9f7b8d5870": "{0}",
  "2c554f960185": "CV Portalen",
  "a918c8de02b7": "Logg inn",
  "55c552133c7f": "Logg ut",

  // business-components/profile/Documents/BasicDocumentUpload.tsx
  "dc8c8f4a4a3b": "Dokumentet er opplastet",
  "e92b863d5c9a": "Velg fil",

  // business-components/profile/Documents/DocumentTimelineContent.tsx
  "89ca7b568fee": "Kunne ikke laste ned dokument",
  "54283d9d8090": "Slette dokument?",
  "f31996621c33": "Er du sikker på at du vil slette dette dokumentet?",
  "26d93ac355a0": "Download",
  "47dc91b81837": "Delete",

  // business-components/profile/Documents/ImportantDocuments.tsx
  "4f001c26eaf1": "Viktige dokumenter",

  // business-components/profile/Documents/MyDocuments.tsx
  "bd615f7645fd": "Opplasting av CV, attest og andre dokumenter",

  // business-components/profile/Privacy/Consent.tsx
  "0cba37a95122": "Jeg har lest og godtar betingelsene over.",
  "baa0f055d92f": "Jeg aksepterer ikke betingelsene over.",

  // business-components/profile/Privacy/Consent5000ForTimeline.tsx
  "f61dff64a2ec": "Jeg har samtykket til at CV-Portalen kan behandle mine personopplysninger i henhold til samtykkeerklæringen.",
  "d3e7c79aad22": "Jeg ønsker å trekke samtykket mitt. Jeg er klar over at dette kan føre til at jeg ikke lenger kan benytte CV-Portalen.",

  // business-components/profile/Privacy/DeleteMe.tsx
  "3a991aa72ba0": "Dersom du ønsker at din profil slettes kan du trykke på knappen under. {0} vil da bli informert og vil gjennomføre slettingen av din profil og personopplysninger så snart som mulig.",

  // business-components/profile/Privacy/DeleteMeContent.tsx
  "bdf4d5345ec5": "Slette profil?",
  "37e47f170436": "ADVARSEL: Når slettingen er fullført er det ikke mulig å angre. Alle dine lagrede dokumenter, personopplysninger og andre data forsvinner for godt. Trykk 'ja' dersom du er helt sikker på at du vil at brukeren din slettes.",
  "d9471daa046b": "Slett min profil",
  "9f760d189175": "Jeg ønsker å slette brukeren min",
  "fd798b7474e5": "Du har bedt om å bli slettet den {0}. Det tar litt tid før forespørselen blir behandlet. Det er {1} som utfører slettingen. Når du ikke lenger kan logge inn har dataene dine blitt slettet. Ta kontakt med {1} hvis du har spørsmål.",
  "086b07553c42": "Logg ut",

  // business-components/profile/Privacy/PrivacyModule.tsx
  "be56ac61e6fd": "Min profil",
  "8e98bddaba9e": "Samtykker",
  "6d7944305f51": "Personvern",
  "b77a25658d11": "Slett meg",
  "3b304c171569": "Samtykker",
  "282fb0546d9e": "Personvern",
  "97996107eb55": "Slett Meg",
}